var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaylistIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OBJECT",
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m28 10.05v-2.05a3 3 0 0 0 -3-3v-1.5a2.5 2.5 0 0 0 -2.5-2.5h-13a2.5 2.5 0 0 0 -2.5 2.5v1.5a3 3 0 0 0 -3 3v2.05a3.5 3.5 0 0 0 -3 3.45v14a3.5 3.5 0 0 0 3.5 3.5h23a3.5 3.5 0 0 0 3.5-3.5v-14a3.5 3.5 0 0 0 -3-3.45zm-19-6.55a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v1.5h-14zm-2 3.5h18a1 1 0 0 1 1 1v2h-20v-2a1 1 0 0 1 1-1zm22 20.5a1.5 1.5 0 0 1 -1.5 1.5h-23a1.5 1.5 0 0 1 -1.5-1.5v-14a1.5 1.5 0 0 1 1.5-1.5h23a1.5 1.5 0 0 1 1.5 1.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16.38 15.21a1 1 0 0 0 -.38.79v5h-3a3 3 0 0 0 0 6h2a3 3 0 0 0 3-3v-6.72l3.73.93.48-1.94-5-1.24a1 1 0 0 0 -.83.18zm-.38 8.79a1 1 0 0 1 -1 1h-2a1 1 0 0 1 0-2h3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylistIcon);
export default __webpack_public_path__ + "static/media/PlaylistIcon.c14e8dc08fc3e5d58acba73bed3f1738.svg";
export { ForwardRef as ReactComponent };